import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { GraduationCap, ArrowRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";

export default function Training() {
  const [modules, setModules] = useState([]);
  const [progress, setProgress] = useState([]);

  useEffect(() => {
    api.get("/content/modules").then((r) => setModules(r.data)).catch(() => {});
    api.get("/progress").then((r) => setProgress(r.data)).catch(() => {});
  }, []);

  const passed = progress.filter((p) => p.passed).length;
  const pct = modules.length ? Math.round((passed / modules.length) * 100) : 0;

  return (
    <div className="space-y-6" data-testid="training-page">
      <PageHeader
        overline="Training"
        title="Employee Training Modules"
        desc="Work through each module and pass the quiz (80% required) to complete it."
        icon={GraduationCap}
        color="text-emerald-600 bg-emerald-50"
      />

      <Card className="p-5">
        <div className="flex items-center justify-between mb-2">
          <span className="font-heading font-bold text-slate-900">Overall progress</span>
          <span className="text-sm text-slate-500">{passed}/{modules.length} passed</span>
        </div>
        <Progress value={pct} className="h-2.5" />
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {modules.map((m) => {
          const p = progress.find((x) => x.module_id === m.id);
          const state = p?.passed ? "done" : p ? "progress" : "todo";
          return (
            <Link key={m.id} to={`/training/${m.id}`} data-testid={`module-card-${m.order}`}>
              <Card className="group h-full p-5 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 border hover:border-emerald-500">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold uppercase tracking-wider text-emerald-600">Module {m.order}</span>
                    <span>{state === "done" ? "✅" : state === "progress" ? "⏳" : "⬜"}</span>
                  </div>
                  {p && <span className="text-xs text-slate-400">Last score {p.score}%</span>}
                </div>
                <h3 className="font-heading font-bold text-slate-900 text-lg mt-2">{m.title}</h3>
                <p className="text-sm text-slate-500 mt-1 line-clamp-2">{m.description}</p>
                <div className="flex items-center gap-1 text-sm font-medium text-emerald-600 mt-4">
                  {state === "done" ? "Review module" : state === "progress" ? "Resume" : "Start module"}
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
